__turbopack_context__.v({
  "border": "DpcvzG_border",
});
